import MDBox from 'components/MDBox';
import { styled } from '@mui/material/styles';
import MDTypography from 'components/MDTypography';

// Main container
export const ChartContainer = styled(MDBox)(({ height }) => ({
  display: 'flex',
  flexDirection: 'column',
  justifyContent: 'center',
  height: height || '100%',
}));

// Chart wrapper
export const ChartWrapper = styled(MDBox)({
  marginTop: 0,
  display: 'flex',
  justifyContent: 'center',
});

// Legend container
export const LegendContainer = styled(MDBox)({
  padding: '0 16px 16px 16px',
});

// Row
export const LegendRow = styled(MDBox)({
  display: 'flex',
  marginBottom: '8px',
  justifyContent: 'space-between',
});

// Left side (dot + label)
export const LegendLeft = styled(MDBox)({
  display: 'flex',
  alignItems: 'center',
});

// Dot
export const LegendDot = styled(MDBox)(({ color }) => ({
  width: 8,
  height: 8,
  marginRight: '8px',
  borderRadius: '50%',
  backgroundColor: color,
}));

// Label
export const LegendText = styled(MDTypography)({
  color: '#7b809a',
  fontSize: '0.75rem', // matches "button"
});

// Value
export const LegendValue = styled(MDTypography)({
  color: '#344767',
  fontWeight: 'bold',
  fontSize: '0.75rem',
});
